import { Box, Button, Flex, Grid } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { NoDataPlaceholder } from 'components/common/table/no-data-placeholder';
import { HitterProfileSummaryFilters } from 'components/sections/hitter-library/profile/summary/filters';
import { HPSummaryHitSpray } from 'components/sections/hitter-library/profile/summary/sections/hit-spray';
import { HPSummaryKeyMetricAverages } from 'components/sections/hitter-library/profile/summary/sections/key-metric-averages';
import { HPSummaryTotalBP } from 'components/sections/hitter-library/profile/summary/sections/total-bp';
import { HitterProfileSummaryTotalPitchTypes } from 'components/sections/hitter-library/profile/summary/sections/total-pitch-types';
import useHitterProfileStore from 'components/sections/hitter-library/profile/use-hitter-profile-store';
import { HPSummarySection } from 'enums/hitter-profile.enums';
import { t } from 'i18next';
import './hitter-profile.scss';

export const HitterProfileSummary = () => {
  const summarySections = useHitterProfileStore((s) => s.summarySections);
  const currSummaryHits = useHitterProfileStore((s) => s.currSummaryHits);
  const loading = useHitterProfileStore((s) => s.loading);

  // todo: handle two empty states - one if no sections to show, one if no data to show
  const notHidingSections = summarySections.length === 0;
  const showPlaceholder = !currSummaryHits.length && !loading;

  return (
    <ErrorBoundary identifier="HitterProfileSummary">
      <Flex direction="column" gap="3">
        <HitterProfileSummaryFilters />
        {showPlaceholder ? (
          <NoDataPlaceholder
            noDataButton={
              <Box mt="2">
                <Button
                  onClick={() =>
                    useHitterProfileStore.getState().resetFilters()
                  }
                  loading={loading}
                >
                  {t('hitters.reset-filters')}
                </Button>
              </Box>
            }
            noDataBody={t('hitters.try-broader-search').toString()}
          />
        ) : (
          <Grid columns={{ xs: '1', md: '2' }} gap="3">
            {(notHidingSections ||
              summarySections.includes(HPSummarySection.TotalBpPitches)) && (
              <HPSummaryTotalBP />
            )}

            {(notHidingSections ||
              summarySections.includes(HPSummarySection.KeyMetricAverages)) && (
              <HPSummaryKeyMetricAverages />
            )}

            {(notHidingSections ||
              summarySections.includes(HPSummarySection.TotalPitchTypes)) && (
              <HitterProfileSummaryTotalPitchTypes />
            )}

            {/* {(notHidingSections ||
              summarySections.includes(HPSummarySection.HitQualityProfile)) && (
              <HPSummaryHitQuality />
            )}

            {(notHidingSections ||
              summarySections.includes(HPSummarySection.ZoneMetrics)) && (
              <HPSummaryZoneMetrics />
            )} */}

            {(notHidingSections ||
              summarySections.includes(HPSummarySection.HitSprayChart)) && (
              <HPSummaryHitSpray />
            )}
          </Grid>
        )}
      </Flex>
    </ErrorBoundary>
  );
};
